<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.CREATE') }} {{ $t('EREPORTER.INVOICES.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <invoice-form
          v-model="form"
          :customer-id="customerId"
          :customer-type="customerType"
          :building-complex="buildingComplex"
          :disabled-building-complex="disabledBuildingComplex"
          :errors="errors"
          @update-prop="updateValue"
        ></invoice-form>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import InvoiceForm from '@/modules/ereporter/components/forms/Invoices/InvoiceManualForm';
import { mapActions } from 'vuex';
import Errors from '@/modules/_global/classes/Errors';
import customerTypes from '@/modules/ereporter/common/Invoices/customerTypes';

export default {
  name: 'CreateInvoice',

  components: { InvoiceForm },

  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    buildingComplex: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: [Errors, Object],
      default: () => ({})
    },
    disabledBuildingComplex: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: Number,
      required: true
    },
    customerType: {
      type: Number,
      required: true,
      validator: prop => Object.values(customerTypes).includes(prop)
    }
  },

  data() {
    return {
      form: {},
      valid: true
    };
  },

  methods: {
    ...mapActions('ereporter', ['createCInvoice']),
    cancel() {
      this.form = {};
      this.valid = true;
      this.$emit('cancel');
    },

    create() {
      this.$emit('create', { ...this.form });
    },

    updateValue(key, value) {
      this.$emit('update-prop', key, value);
    }
  }
};
</script>
